/**
 * Add more tag definitions here with the tag name as the key and the definition as the value.
 *
 * Ensure casing is consistent with the tag in the doc page.
 *
 * Tag definitions are used to display a tooltip when the user hovers over a tag on docs pages only.
 * If no definition is provided, the tag will be displayed, but the tooltip will not be shown.
 */
export const tagDefinitions: Record<string, string> = {
  'SigNoz Cloud': 'This page applies to SigNoz Cloud editions.',
  'Self-Host': 'This page applies to self-hosted SigNoz editions.',
  'Self-Hosted Enterprise': 'This page applies to self-hosted SigNoz with an active license.',
  'Self-Hosted Community': 'This page applies to self-hosted SigNoz without a license.',
}
